import useProtectedQuery from './use-protected-query';

import RebatesClient from '../RebatesClient';

/**
 * Fetches flattened invoice rows for the statement builder from
 * GET /api/report/statement-builder-invoices.
 *
 * Refetches whenever the period (start/end) or selected farm ids change.
 * Disabled until a valid period and at least one farm id are present.
 *
 * @param {Object} args
 * @param {string|null} args.start    YYYY-MM-DD
 * @param {string|null} args.end      YYYY-MM-DD
 * @param {string[]}    args.farmIds  selected child/farm account ids
 */
export default function useStatementBuilderInvoices({ start, end, farmIds }) {
  const farmIdsParam = (farmIds || []).join(',');
  const enabled = Boolean(start && end && farmIdsParam);

  const {
    data: invoices,
    isLoading: invoicesLoading,
    isRefetching: invoicesRefetching,
    error: invoicesError,
    refetch: refetchInvoices
  } = useProtectedQuery({
    queryKey: ['statement_builder_invoices', start, end, farmIdsParam],
    enabled,
    queryFn: async () => {
      const url =
        `/api/report/statement-builder-invoices?start=${encodeURIComponent(start)}` +
        `&end=${encodeURIComponent(end)}` +
        `&farm_acct_ids=${encodeURIComponent(farmIdsParam)}`;

      const result = await RebatesClient.standardFetch(url);

      if (result.response.ok) {
        return result.body?.invoices || [];
      }
      throw new Error('Error getting statement builder invoices');
    }
  });

  return {
    invoices: invoices || [],
    invoicesLoading,
    invoicesRefetching,
    invoicesError,
    refetchInvoices
  };
}
